import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import {
  remitterAccountApprove,
  remitterAccountDetailsById,
  remitterAccountReject,
} from "../../../../redux/features/accounts/remitterAccount/remitterAccount";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import CommonToast from "../../../../components/_utils/CommonToast";
import { toast } from "react-toastify";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";

const RemitterAccountSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [rejectPopup, setRejectPopup] = useState(false);
  const [declineReason, setDeclineReason] = useState("");

  const services = useSelector((state) => state.refreshToken.services);

  const { remitterAccountDetailsData } = useSelector(
    (state) => state.remitterAccount,
  );

  const remitterAccountData = remitterAccountDetailsData;

  const consolidatedBankHandler = () => {
    navigate("/owner_account_dashboard/view_consolidated_statement", {
      replace: true,
    });
  };

  const liveBankHandler = () => {
    navigate("/owner_account_dashboard/itemized_activity_feed", {
      replace: true,
    });
  };

  const createAccountHandler = () => {
    navigate("/remitter_account_dashboard/create_remitter_account", {
      replace: true,
    });
  };

  const viewDetailsHandler = () => {
    navigate(
      `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${id}`,
      { replace: true },
    );
  };

  const dashboardHandler = () => {
    navigate("/remitter_account_dashboard", { replace: true });
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const accountApproval = () => {
    (async () => {
      setShowLoader(true);
      toast.dismiss();
      CommonToast({
        text: "Remitter account getting approved.",
        variant: "var(--processing)",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      });
      let response = await dispatch(remitterAccountApprove({ id }));
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Remitter account approved.",
          variant: "var(--success)",
          icon: ICONS.SELECTED_WITH_WHITE_FILLED,
          buttonNeeded: false,
        });

        navigate(
          `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${id}`,
          { replace: true },
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.remitter_account[0],
          variant: "var(--error)",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
        });
      }
    })();
  };
  const accountRejected = () => {
    (async () => {
      setShowLoader(true);
      toast.dismiss();
      CommonToast({
        text: "Remitter account getting rejected.",
        variant: "var(--processing)",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      });
      let response = await dispatch(
        remitterAccountReject({
          id,
          rejection_reason: declineReason,
        }),
      );
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Remitter account rejected.",
          variant: "var(--success)",
          icon: ICONS.SELECTED_WITH_WHITE_FILLED,
        });

        navigate(
          `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${id}`,
          { replace: true },
        );
      } else {
        toast.dismiss();
        CommonToast({
          text: response?.payload?.errors?.remitter_account[0],
          variant: "var(--error)",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
        });
        setRejectPopup(false);
      }
    })();
  };
  const handleInputChange = (event) => {
    let value = event?.target?.value;
    value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    value = value.replace(/^\s+/, "");
    value = value.replace(/\s{2,}/g, " ");
    value = value.slice(0, 150);
    setDeclineReason(value);
  };

  const primaryBtn = {
    enabledBgColor: "var(--text-primary)",
    enabledTextColor: "var(--positive-bg)",
    iconToBeAlign: "left",
    fullWidthRequired: true,
    imgColor: "var(--positive-bg)",
    hoverOption: "dark",
  };

  const outlineBtn = {
    enabledBgColor: "var(--bg-positive-bg)",
    enabledTextColor: "var(--text-primary)",
    iconToBeAlign: "left",
    fullWidthRequired: true,
    outLineColor: "var(--text-primary)",
    hoverOption: "dark",
  };

  const buttonRows = [
    ...(services?.includes("REAAccount") ||
    (services?.includes("Admin") &&
      remitterAccountData?.approval_status === "pending")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_CIRCLE_RED_ICON,
              handleFunction: () => {
                setRejectPopup(true);
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECTED_WITH_WHITE_FILLED,
              handleFunction: () => {
                accountApproval();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
          ],
        ]
      : []),

    [
      {
        ...primaryBtn,
        btnText: "Consolidated bank statement",
        icon: ICONS?.MATCHED_WITH_CIRCLE,
        handleFunction: consolidatedBankHandler,
      },
      {
        ...primaryBtn,
        btnText: "Consolidated live statement",
        icon: ICONS?.MATCHED_WITH_CIRCLE,
        handleFunction: liveBankHandler,
      },
      {
        ...primaryBtn,
        btnText: "Create account",
        icon: ICONS.SELECTUSER,
        handleFunction: createAccountHandler,
      },
      {
        ...primaryBtn,
        btnText: "View details",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
      },
      {
        ...outlineBtn,
        btnText: "Go to dashboard",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
      },
    ],
  ];

  useEffect(() => {
    dispatch(remitterAccountDetailsById({ id }));
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [id, dispatch]);

  return (
    <div>
      {rejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the account."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            // noteText="Before rejecting the account, any matched transactions (if present) will need to be unmatched in the following steps."
            noteColor="text-secondary"
            inputPlaceholder={globalText.REASON_10_150_CHAR}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="big"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              setRejectPopup(false);
              setDeclineReason("");
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              accountRejected();
              setDeclineReason("");
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              declineReason.trim().length <
              GlobalConfiguration.rejectReasonMinLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={"Remitter account created successfully and awaiting approval."}
      >
        <TabsWeapperSection title="Account details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountNameStandardised(remitterAccountData?.name),
                  leftSubTitle: "Account name",
                },
              ]}
            />
            {/* <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: remitterAccountData?.labels
                    ? remitterAccountData?.labels || ""
                    : "Not assigned",
                  // leftTitle: "Not assigned",
                  leftSubTitle: "Labels (optional)",
                },
              ]}
            /> */}
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
};

export default RemitterAccountSuccess;
